import React from "react";
import { Trash2, RefreshCw } from "lucide-react";

const BADGE = {
  live: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  error: "bg-red-500/10 text-red-400 border-red-500/30",
  off: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  checking: "bg-amber-500/10 text-amber-400 border-amber-500/30",
};

function badgeText({ state, probe, cfg }) {
  if (state === "checking") return "CHECKING…";
  if (state === "off") return "NOT CONFIGURED";
  if (state === "live") return `LIVE · ${probe.domains_count} domain(s) · primary ${probe.primary_domain || cfg.primary_domain || "?"}`;
  return `CONFIGURED but FAILING · ${probe?.error || ""}`;
}

/** Title row: state badge + refresh / replace key / remove actions. */
export function GwsSettingsHeader({ s }) {
  const { cfg, state, busy } = s;
  return (
    <div className="px-5 py-3 border-b border-zinc-800 flex items-center gap-3 flex-wrap">
      <div className="label-tiny">Google Workspace</div>
      <span data-testid="gws-settings-badge" className={`inline-block border mono text-[11px] uppercase tracking-wider px-2 py-1 rounded-sm ${BADGE[state]}`}>
        {badgeText(s)}
      </span>
      {cfg?.configured && (
        <div className="ml-auto flex items-center gap-2">
          <button data-testid="gws-settings-refresh" onClick={s.load} disabled={busy} className="text-zinc-400 hover:text-white p-1"><RefreshCw size={13} /></button>
          <button data-testid="gws-settings-edit" onClick={s.startEdit} className="text-xs border border-zinc-700 hover:border-zinc-400 px-2.5 py-1 rounded-sm">Replace key</button>
          <button data-testid="gws-settings-remove" onClick={s.remove} disabled={busy} className="text-xs text-zinc-500 hover:text-red-400 inline-flex items-center gap-1 px-2 py-1"><Trash2 size={12} /> Remove</button>
        </div>
      )}
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div className="border border-zinc-800 rounded-sm px-3 py-2">
      <div className="text-[10px] uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="mono text-zinc-200 break-all">{children}</div>
    </div>
  );
}

/** Read-only summary of the stored service account. */
export function GwsSettingsSummary({ cfg, probe }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-xs">
      <Field label="Service account">{cfg.client_email}</Field>
      <Field label="Client ID (for DWD)">{cfg.client_id}</Field>
      <Field label="Impersonated super-admin">{cfg.subject}</Field>
      <Field label="Primary domain">{cfg.primary_domain || probe?.primary_domain || "—"}</Field>
      <Field label="DMARC reports to">{cfg.dmarc_rua || "— (p=none, no rua)"}</Field>
      <Field label="Source">{cfg.source}</Field>
    </div>
  );
}
